// extracted by mini-css-extract-plugin
export var curr = "vintage_plp-module--curr--c2b93";
export var title = "vintage_plp-module--title--e5a4c";
export var vemail = "vintage_plp-module--vemail--7034f";
export var vemail_form = "vintage_plp-module--vemail_form--07b4b";
export var vemail_wr = "vintage_plp-module--vemail_wr--f61f4";
export var vinplp = "vintage_plp-module--vinplp--33f34";
export var vinplp_count = "vintage_plp-module--vinplp_count--829c1";
export var vinplp_head = "vintage_plp-module--vinplp_head--c2df6";
export var vinplp_sort = "vintage_plp-module--vinplp_sort--fb5b9";
export var vinplp_title = "vintage_plp-module--vinplp_title--620af";
export var vint_bar = "vintage_plp-module--vint_bar--d15bf";
export var vsoon = "vintage_plp-module--vsoon--ab1db";
export var vsoon_copy = "vintage_plp-module--vsoon_copy--bfe18";
export var vsoon_image = "vintage_plp-module--vsoon_image--48ecd";
export var vsoon_img = "vintage_plp-module--vsoon_img--db0c6";
export var vtile = "vintage_plp-module--vtile--1f932";
export var vtile_data = "vintage_plp-module--vtile_data--30d15";
export var vtile_drop = "vintage_plp-module--vtile_drop--8de70";
export var vtile_image = "vintage_plp-module--vtile_image--e5ee4";
export var vtile_img = "vintage_plp-module--vtile_img--0de33";
export var vtile_info = "vintage_plp-module--vtile_info--6929d";
export var vtile_infos = "vintage_plp-module--vtile_infos--914f6";
export var vtile_label = "vintage_plp-module--vtile_label--10300";
export var vtile_price = "vintage_plp-module--vtile_price--0d6ee";
export var vtile_title = "vintage_plp-module--vtile_title--75c93";
export var vtiles = "vintage_plp-module--vtiles--383ef";